import { mapActions } from 'vuex';
import { API_URL } from '../constants';

export default {
  data() {
    return {
      API_URL,
      identityDocument: [],
      extraIdentityDocument: [],
      residenceDocument: [],
    };
  },
  computed: {
    nextButtonTheme() {
      const hasId = (this.identityDocument && this.identityDocument.length)
        || this.previousIdentityDocument;
      const hasProofOfAddress = (this.residenceDocument && this.residenceDocument.length)
         || this.previousProofOfAddress;
      if (hasId && hasProofOfAddress) {
        return 'primary';
      }
      return 'disabled';
    },
    previousIdentityDocument() {
      if (this.form && this.form.attributes) {
        return this.form.attributes.identityDocumentHash;
      }
      return null;
    },
    previousExtraIdentityDocument() {
      if (this.form && this.form.attributes) {
        return this.form.attributes.extraIdentityDocumentHash;
      }
      return null;
    },
    previousProofOfAddress() {
      if (this.form && this.form.attributes) {
        return this.form.attributes.proofOfAddressHash;
      }
      return null;
    },
  },
  methods: {
    ...mapActions('kyc', ['uploadIdentityDocument', 'uploadExtraIdentityDocument',
      'uploadProofOfAddress']),
    next() {
      this.$router.push('/kyc/success');
    },
  },
};
